import { render, staticRenderFns } from "./InsNews.vue?vue&type=template&id=7f3cfdb8&scoped=true"
import script from "./InsNews.vue?vue&type=script&lang=ts"
export * from "./InsNews.vue?vue&type=script&lang=ts"
import style0 from "./InsNews.vue?vue&type=style&index=0&id=7f3cfdb8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3cfdb8",
  null
  
)

export default component.exports